import React from "react";
import {
    LargePrimaryButton,
    LargeSecondaryButton,
    LongCtaPopup,
    ModalPattern,
} from "@worthy-npm/clarity";
import I18n from "lib/i18n/i18n";
import {
    STEP_ADDRESS,
    STEP_PICKUP,
    STEP_PHONE,
    INSURANCE_CERTIFICATE_LINK,
    SHIPMENT_METHOD,
    NEW,
    IN_TRANSIT,
    LL_SK_EXP_VERSION,
    imageUrl,
    isMobile,
    requestShippingKitPopupText,
    STEP_MESSAGE,
    VALIDATION_NEEDED,
} from "helpers/ApplicationHelper";

import LightListing from "./lightListing";
import UserActions from "lib/userActions";
import ScheduleShipment from "../scheduleShipment/scheduleShipment";

import { requestShippingKit } from "../../actions/shipment";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ScheduleShipmentModalPopup from "../popups/scheduleShipmentModalPopup";
import DropOffOfficesModalPopup from "../popups/dropOffOfficesModalPopup";
import CalendlyHelper from "lib/calendly";
import { BannerText } from "@worthy-npm/worthy-ui-components";
import _ from "lodash";
import { isHighValueLeads, isJBLeads, isUltraValueLeads } from "../../helpers/itemHelper";
import { browserHistory } from "react-router";
import GA from "../../lib/ga";
import PropTypes from "prop-types";
import cookie from "react-cookie";
import Tip from "./Tip";
import PopupInPersonAptTips from "../popups/popupInPersonAptTips";

class UpNext extends React.Component {
    constructor(props) {
        super(props);
        this.isMobile = isMobile();
        this.dropOffOffices = props.item.drop_off_offices || [];
        this.state = { openSchedulePickupForm: props.openSchedulePickupFormByProp };
        this.lastCalendlyUrl = '';
    }

    isCalendlyEvent(e) {
        return e.data.event?.indexOf("calendly") === 0;
    }

    isShowInPersonApt(){
        // return this.dropOffOffices.length > 0 || this.forceShowInPersonAppt();
        return this.forceShowInPersonAppt();
    }

    isDisableSetUpShipment(){
        const { item } = this.props;

        let isWatchDisabled = false;

        if (item.item_type === "watch" && !item.premium_brand) {
            const photoState = ["quick-sale", "approve", "auction", "tender"];
            isWatchDisabled =
                item.workflow_state === VALIDATION_NEEDED ||
                !photoState.includes(item.photo_validation_review);
        }

        return _.get(item, "submission_qualification", false) || isWatchDisabled;
    }

    componentDidMount() {
        CalendlyHelper.loadCalendly();
        window.addEventListener("message", this.calendlyEvent);

        const { item, version } = this.props;

        GA.lightListingOpen(
            item.value_category,
            this.isShowInPersonApt(),
            (this.dropOffOffices[0] || {}).title
        );

        if (this.isShowInPersonApt()) {
            this.logAction("Office drop off button presented", {
                itemId: item.id,
                version: version,
            });
        }

        this.backListener = browserHistory.listen((location) => {
            Calendly.closePopupWidget();
        });
    }

    calendlyEvent = (e) => {
        if (this.isCalendlyEvent(e)) {
            if (e.data.event.indexOf("event_scheduled") > -1) {
                const uriProps = e.data.payload.invitee.uri.split("/");
                const { item } = this.props;
                const calendlyType = this.lastCalendlyUrl.replace('https://calendly.com/', '');

                this.logAction(`Schedule ${item.value_category} call set using ${calendlyType} Calendly`, {
                    itemId: this.props.item.id,
                    version: this.props.version,
                });
                GA.lightListingScheduleCtasSuccess().scheduleCall();
                this.props.dateChanged(uriProps[4]);
            }
        }
    };

    componentWillUnmount() {
        CalendlyHelper.removeCalendly();
        this.backListener();
    }

    closeSchedulePickupForm = (step) => {
        this.setState({ openSchedulePickupForm: false, step: step });
        if (this.stopAnimation) {
            this.stopAnimation();
        }
    };

    logAction = (message, params) => {
        UserActions.lightListingPage(message, params.itemId, params.version);
    };

    shipmentScheduledSuccessfully = () => {
        GA.lightListingScheduleCtasSuccess().schedulePickup();
        this.setState({ step: STEP_MESSAGE });
    };

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.openSchedulePickupFormByProp !==
            prevProps.openSchedulePickupFormByProp
        ) {
            this.setState({
                openSchedulePickupForm: this.props.openSchedulePickupFormByProp
            });
        }
    }

    // TODO: must be unified with listing.js component methods
    onRequestSK = () => {
        // SK is temporarily turned off for Light Listing - showRequestSKPopup: true,
        this.setState({ openSchedulePickupForm: false });
    };

    hideSKPopup = () => {
        this.setState({ showRequestSKPopup: false });
    };

    renderRequestSKPopup = () => {
        const { item } = this.props;

        return (
            <div className="shipping-kit-request-popup">
                <div className="shipping-kit-request-popup__inner">
                    <LongCtaPopup
                        headline={I18n.getString(
                            "shippingKit::popup::headline"
                        )}
                        html={requestShippingKitPopupText(
                            item.shipment.shipment_method
                        )}
                        declineButtonText={I18n.getString(
                            "shippingKit::popup::declineButton"
                        )}
                        approveButtonText={I18n.getString(
                            "shippingKit::popup::approveButton"
                        )}
                        declineButtonClick={() => this.hideSKPopup()}
                        approveButtonAutomationAttribute="get-shipping-kit-btn"
                        approveButtonClick={(stopAnimation) => {
                            this.doRequestSK(stopAnimation);
                        }}
                    />
                </div>
            </div>
        );
    };

    doRequestSK = (stopAnimation) => {
        const { onSuccess, item, experiments, requestShippingKit } = this.props;

        if (!item || !experiments) {
            console.error(
                "Either item or experiments are missing in props input object"
            );
            return;
        }

        this.logAction("Get shipping kit - approved", {
            itemId: item.id,
            version: this.props.version,
        });

        if (this.isMobile) {
            this.hideSKPopup();
        }

        return requestShippingKit(item.id)
            .then(() => {
                if (onSuccess) {
                    onSuccess();
                }
                if (stopAnimation) {
                    stopAnimation();
                }
            })
            .catch(() => {
                if (stopAnimation) {
                    stopAnimation();
                }
            });
    };

    openSSFonMobileHere = (itemId, step) => {
        // alert('openSSFonMobileHere')
        const { item, experiments, ADO } = this.props;
        this.logAction("Set up shipment modal presented", {
            itemId,
            version: LightListing.getVersion({ item, experiments, ADO }),
        });
        this.setState({ openSchedulePickupForm: true, step: step });
    };

    forceShowInPersonAppt(){
        return cookie.load('force-show-in-person-appt-btn') === 'true'
    }

    render() {
        let {
            openSchedulePickupForm,
            showRequestSKPopup,
        } = this.state;
        const { item, ADO, experiments, step, appointment } = this.props;
        const version = LightListing.getVersion({ item, ADO, experiments });

        const isUltra = isUltraValueLeads(item);
        const canUltraShip = item.workflow_state === "shipping" &&
            item.shipment?.shipment_method !== SHIPMENT_METHOD["In-Person Drop Off"] ||
            !item.is_insurance_limit_reached;
        const showSchedulePickup = !isUltra || canUltraShip;
        const showInPersonApt = this.isShowInPersonApt();
        const flippedCTAs = isHighValueLeads(item) || isJBLeads(item) || isUltra;

        let NEXT_UP_BUTTON_TEXT = I18n.getString("listingPage::scheduleButtonNotSecure");
        let NEXT_UP_BUTTON_STEP =
            step ||
            (item.shipment && item.shipment.formatted_address ? STEP_PICKUP : STEP_PHONE);

        const requestShippingKitExperiment = LightListing.getVersion(this.props) === LL_SK_EXP_VERSION;

        const SKNew = item.shipping_kit && item.shipping_kit.status === NEW;
        const SKInTransit =
            item.shipping_kit && item.shipping_kit.status === IN_TRANSIT;
        const shippingKitNotYetDelivered =
            item.shipment &&
            requestShippingKitExperiment &&
            (SKNew || SKInTransit);

        if (
            item.shipment &&
            item.shipment.formatted_address &&
            !shippingKitNotYetDelivered
        ) {
            NEXT_UP_BUTTON_STEP = STEP_PICKUP; // We need it for Desktop version
            NEXT_UP_BUTTON_TEXT = I18n.getString("shipmentInformation::schedulePickupButton");
            if (item.shipment.shipment_method === SHIPMENT_METHOD["Pickup"]) {
                NEXT_UP_BUTTON_TEXT = I18n.getString("shipmentInformation::editPickupButton");
            }
        }

        const eventsParams = {
            itemId: item.id,
            version,
        };

        const nextUpClick = (stopAnimation) => {
            const message = `${
                item.shipment ? "Edit" : "Schedule Pickup"
            } button clicked (Next Up) [${
                this.isMobile ? "mobile" : "desktop "
            }]`;
            GA.lightListingScheduleCtasClicked().schedulePickup();

            this.logAction(message, eventsParams);
            stopAnimation();

            if (this.isMobile) {
                this.setState({
                    openSchedulePickupForm: true,
                    step: NEXT_UP_BUTTON_STEP,
                });
            } else {
                ScheduleShipmentModalPopup.initPopup({
                    step: NEXT_UP_BUTTON_STEP,
                    onShipmentScheduled: (data) => {
                        this.shipmentScheduledSuccessfully(data);
                    },
                    stopAnimation: stopAnimation,
                    version,
                    itemId: item.id,
                });
            }
        };

        const dropOffOfficesDialog = (stopAnimation) => {
            stopAnimation();

            DropOffOfficesModalPopup.initPopup({
                popupClassName: "popup-drop-off-offices",
                onSuccess: (scheduledOffice) => {
                    GA.lightListingScheduleCtasSuccess().scheduleInPersonAppointment(
                        (this.dropOffOffices[0] || {}).title,
                        scheduledOffice
                    );
                },
            });
        };

        const IN_PERSON_APT_TIPS = (
            <div className="in-person-atp-cta">
                <a href="#"
                   onClick={(e) => {
                       e.preventDefault();
                       PopupInPersonAptTips.initPopup({
                           popupClassName: 'popup-tip',
                           showSchedulePickup: showSchedulePickup
                       })
                   }}
                >
                    More about these options
                </a>
            </div>

        )

        const dropOffOfficesButton = (blueButton = false) => {
            const Button = blueButton ? LargePrimaryButton : LargeSecondaryButton;
            return (
                <>
                    <div className="submit-clarity-button-wrapper reschedule-btn tips-container">
                        <Button
                            overrideCSS={{ width: "100%", marginTop: "12px" }}
                            overrideWrapperCSS={{ width: "100%" }}
                            text="Deliver in Person"
                            click={(stopAnimation) => {
                                GA.lightListingScheduleCtasClicked().scheduleInPersonAppointment(
                                    (this.dropOffOffices[0] || {}).title
                                );
                                return dropOffOfficesDialog(stopAnimation);
                            }}
                        />

                        <Tip showSchedulePickup={showSchedulePickup}>Meet with a trusted expert at a location near you and hand deliver your item.</Tip>
                    </div>
                    {IN_PERSON_APT_TIPS}
                </>
            );
        };

        const disableSetUpShipment = this.isDisableSetUpShipment();

        const scheduleCallClicked = async (logMessage, stopAnimation) => {
            GA.lightListingScheduleCtasClicked().scheduleCall();
            const link = await CalendlyHelper.getCalendlyLinkByValueCategory(item, ADO?.user?.id, ADO?.user?.unverified_registration);
            this.lastCalendlyUrl = link;
            CalendlyHelper.showPopupWidget("from lld secondary", link, CalendlyHelper.calendlyParams(item, ADO));
            this.logAction(logMessage, eventsParams);
            stopAnimation();
        };

        const scheduledTime = _.get(appointment, "scheduledTime", "");

        const scheduleCallButton = (blueButton = false) => {
            const Button = blueButton ? LargePrimaryButton : LargeSecondaryButton;
            return (
                <div className={`submit-clarity-button-wrapper reschedule-btn`}>
                    <Button
                        click={(stopAnimation) => {
                            scheduleCallClicked(
                                scheduledTime
                                    ? "Re-schedule call modal presented"
                                    : "Schedule call modal presented",
                                stopAnimation
                            );
                        }}
                        text={
                            scheduledTime
                                ? I18n.getString("listingPageLight::upNext::reScheduleButton")
                                : I18n.getString("listingPage::scheduleVIPCall")
                        }
                        dataAutomation="up-next-reschedule-call"
                        overrideCSS={{width: "100%", marginTop: "12px"}}
                        overrideWrapperCSS={{width: "100%"}}
                    />
                </div>
            )
        };

        const pickupButton = (blueButton = false ) => {
            const Button = blueButton ? LargePrimaryButton : LargeSecondaryButton;
            return (
                <div className="submit-clarity-button-wrapper reschedule-btn">
                    <Button
                        click={(stopAnimation) => {
                            nextUpClick(stopAnimation);
                        }}
                        disabled={disableSetUpShipment}
                        text={NEXT_UP_BUTTON_TEXT}
                        dataAutomation="up-next-set-up-shipment"
                        overrideCSS={{width: "100%", fontWeight: 500}}
                        overrideWrapperCSS={{width: "100%", marginTop: "12px"}}
                    />
                </div>
            );
        }

        const staticTips = () => {
            return <div className={"trust-logos-seller-note-container"}>
                {
                    disableSetUpShipment
                        ? <BannerText>{I18n.getString(`listingPageLight::upNext::sellerNote`)}</BannerText>
                        : <>
                            <img src={imageUrl("common/logos/fedex_gray_logo.svg")} alt="Fedex"/>
                            <img src={imageUrl("common/logos/lloyds_gray.svg")} alt="Lloyds"/>
                            <img src={imageUrl("common/logos/gray_GIA.svg")} alt="GIA"/>
                         </>
                }
            </div>
        }

        const isAloneButton = (!showSchedulePickup || disableSetUpShipment) && !showInPersonApt

        return (
            <>
                <span className="item-upper-caption outside-box">
                    {I18n.getString("listingPageLight::upNext::upperTitle")}
                </span>
                <div className="pane-listing">
                    {showRequestSKPopup ? this.renderRequestSKPopup() : null}
                    {openSchedulePickupForm ? (
                        <ModalPattern
                            key={"ModalPattern"}
                            textAlign={"center"}
                            title={I18n.getString(
                                `listingPage::${ step === STEP_ADDRESS ? "setUpShipmentTitle" : "scheduleShipmentTitle"}`
                            )}
                            closeIcon={true}
                            closeOnClickOutside={false}
                            closeOnEscape={false}
                            isWide={true}
                            onClose={() => {
                                this.setState({
                                    openSchedulePickupForm: false,
                                });
                                this.props.onSSSFClose();
                            }}
                        >
                            <ScheduleShipment
                                openSchedulePickupFormForMobile={
                                    this.openSSFonMobileHere
                                }
                                version={LightListing.getVersion(this.props)}
                                onClose={(step) => {
                                    this.closeSchedulePickupForm(step);
                                }}
                                logger={this.logAction}
                                onRequestShippingKit={this.onRequestSK}
                                isSKExperiment={false}
                                onShipmentScheduled={(data) => {
                                    this.shipmentScheduledSuccessfully(data);
                                }}
                                step={step}
                            />
                        </ModalPattern>
                    ) : null }

                    <div className={"up-next"}>
                        <h5 className="up-next-title">
                            {
                                item.shipment && item.shipment.shipment_method === SHIPMENT_METHOD["In-Person Drop Off"]
                                    ? "In-Person Appointment"
                                    : disableSetUpShipment
                                        ? I18n.getString("listingPageLight::upNext::title_scheduling")
                                        : I18n.getString("listingPageLight::upNext::title")
                            }
                        </h5>

                        <ul className="up-next-service-list">
                            <li className="up-next-service">
                                <span className="up-next-service__name">
                                    {I18n.getString("listingPageLight::upNext::serviceFedex")}
                                </span>
                                <span className="up-next-service__price up-next-service__price_real">$25</span>
                                <span className="up-next-service__price up-next-service__price_actual">$0</span>
                            </li>
                            <li className="up-next-service">
                                <span className="up-next-service__name">
                                    {isUltra ? (
                                        <>{I18n.getString("listingPageLight::upNext::insuranceCoverage")}</>
                                    ) : (
                                        <>
                                            <a
                                                href={INSURANCE_CERTIFICATE_LINK}
                                                target={this.isMobile ? "_self" : "_blank"}
                                                rel="noreferrer"
                                            >
                                                {I18n.getString("listingPageLight::upNext::insurance")}
                                            </a>
                                            {I18n.getString("listingPageLight::upNext::upTo")}
                                        </>
                                    )}
                                </span>
                                <span className="up-next-service__price up-next-service__price_real">$50</span>
                                <span className="up-next-service__price up-next-service__price_actual">$0</span>
                            </li>
                        </ul>

                        <React.Fragment>
                            { flippedCTAs ? scheduleCallButton(isAloneButton) : null }
                            { showSchedulePickup ? pickupButton(true) : null }
                            { flippedCTAs ? null : scheduleCallButton(isAloneButton) }
                            { showInPersonApt ? dropOffOfficesButton(true) : null }
                            { staticTips() }
                        </React.Fragment>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = ({ ADO, Item, Experiments, Personalized }) => {
    return {
        item: Item,
        ADO,
        experiments: Experiments,
        P13N: Personalized,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ requestShippingKit }, dispatch);
};

UpNext.propTypes = {
    version: PropTypes.string,
    openSchedulePickupFormByProp: PropTypes.bool,
    item: PropTypes.shape({
        id: PropTypes.string,
        premium_brand: PropTypes.bool,
        is_insurance_limit_reached: PropTypes.bool,
        fake_estimate: PropTypes.bool,
        has_active_appointment: PropTypes.bool,
        shipping_kit: PropTypes.shape({
            id: PropTypes.number,
            status: PropTypes.string,
            tracking_url: PropTypes.string,
        }),
        shipment: PropTypes.shape({
            shipment_method: PropTypes.number,
            formatted_address: PropTypes.string,
        }),
        photos: PropTypes.array,
        drop_off_offices: PropTypes.array,
        workflow_state: PropTypes.string,
        item_type: PropTypes.string,
        photo_validation_review: PropTypes.string,
        value_category: PropTypes.string,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(UpNext);
